import ApiService from "@/services/api.service"
export async function getLogbook(propertyId){
    const response = await ApiService.get("logbook/"+propertyId+"/full");
    return response.data;
}

export async function addLogbookEntry(entry,realEstateId){
    const response = await ApiService.post("logbook/"+realEstateId+"/add",entry);
    return response.data;
}